import { render, staticRenderFns } from "./MenuToppings.vue?vue&type=template&id=04f1b100&scoped=true&"
import script from "./MenuToppings.vue?vue&type=script&lang=js&"
export * from "./MenuToppings.vue?vue&type=script&lang=js&"
import style0 from "./MenuToppings.vue?vue&type=style&index=0&id=04f1b100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f1b100",
  null
  
)

export default component.exports